export const QueryKeys = {
  devices: "getDevices",
  customers: "getCustomers",
} as const;
